import colors from 'sass/prime-vue/_colours.module.scss';
import variables from 'sass/prime-vue/_variables.module.scss';

const tokens: PrimeVueCustomDesignTokens = {
  primitive: {
    shadows: {
      none: 'none'
    },
    durations: {
      s0: '0s'
    },
    offset: {
      none: 'none'
    }
  },
  input: {
    background: {
      color: colors.inputBackgroundColor
    },
    shadow: {
      default: colors.inputShadow,
      focus: colors.inputFocusShadow,
      error: colors.inputErrorShadow
    },
    border: {
      colors: {
        focus: colors.inputFocusBorderColor,
        error: colors.inputErrorBorderColor,
        default: colors.inputBorderColor
      },
      radius: variables.inputBorderRadius as string
    }
  },
  text: {
    colors: {
      default: colors.inputTextColor,
      readonly: colors.inputTextColorReadonly,
      placeholder: colors.inputPlaceholderColor
    }
  },
  button: {
    background: {
      colors: {
        hover: colors.buttonDefaultHoverBackground,
        default: 'white'
      }
    },
    border: {
      colors: {
        hover: colors.buttonDefaultHoverBorder,
        default: colors.buttonDefaultBorder
      },
      radius: colors.buttonDefaultBorderRadius
    },
    focusRing: {
      width: '5px',
      color: 'black',
      style: 'auto',
      shadow: 'none',
      offset: '-2px'
    }
  },
  navigation: {
    vertical: {
      background: {
        selected: variables.navYBackgroundSelected
      },
      border: {
        hover: variables.navYBorderHover,
        selected: variables.navYBorderSelected
      }
    }
  },
  list: {
    option: {
      background: {
        colors: {
          hover: colors.dropdownOptionFocusColor,
          selected: colors.dropdownOptionSelectedColor,
          hoverSelected: colors.dropdownOptionSelectedFocusColor,
          default: 'white'
        }
      },
      text: {
        colors: {
          selected: colors.dropdownOptionSelectedTextColor
        }
      }
    }
  }
};

export default tokens;

export type PrimeVueCustomDesignTokens = {
  primitive: {
    shadows: {
      none: string
    },
    durations: {
      s0: string
    },
    offset: {
      none: string
    }
  },
  input: {
    background: {
      color: string
    },
    shadow: {
      default: string,
      focus: string,
      error: string
    },
    border: {
      colors: {
        focus: string,
        error: string,
        default: string
      },
      radius: string
    }
  },
  text: {
    colors: {
      default: string,
      readonly: string,
      placeholder: string
    }
  },
  button: {
    background: {
      colors: {
        hover: string,
        default: string
      }
    },
    border: {
      colors: {
        hover: string,
        default: string
      },
      radius: string
    },
    focusRing: {
      width: string,
      color: string,
      style: string,
      shadow: string,
      offset: string
    }
  },
  navigation: {
    vertical: {
      background: {
        selected: string
      },
      border: {
        hover: string,
        selected: string
      }
    }
  },
  list: {
    option: {
      background: {
        colors: {
          hover: string,
          selected: string,
          hoverSelected: string,
          default: string
        }
      },
      text: {
        colors: {
          selected: string
        }
      }
    }
  }
};